

import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";


const navItems = [
  { name: "Home", path: "/" },
  { name: "Projects", path: "/project" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);


 

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Main Navbar */}
      <header className="fixed top-0 left-0 right-0 z-50">
        <div className="max-w-[1300px] mx-auto w-full md:px-0 px-6">
          <div className="flex items-center justify-between h-20">
            
            {/* Left - Name */}
            <motion.div
              initial={{ opacity: 1 }}
              animate={{ opacity: scrolled ? 0 : 1 }}
              transition={{ duration: 0.3 }}
              className={scrolled ? "pointer-events-none" : ""}
            >
              <NavLink
             
                className="text-white text-xl lg:text-2xl font-light lowercase tracking-wide hover:opacity-70 transition-opacity"
              >
                <Link    to="/" >pelumi.
                </Link>
               
              </NavLink>
            </motion.div>

            {/* Right - Actions */}
            <div className="flex items-center gap-3 ml-auto">

         
              <motion.button
               
                initial={{ opacity: 1, scale: 1 }}
                animate={{
                  opacity: scrolled ? 0 : 1,
                  scale: scrolled ? 0.8 : 1,
                }}
                transition={{ duration: 0.3 }}
               
              >
                <Link to="/contact"><button  className="inline-flex items-center gap-2 justify-center
                  px-6 py-3 md:px-4 md:py-2
                  text-sm md:text-base font-semibold tracking-wide
                  bg-white text-[#171718] rounded-md
                  transition-colors duration-300
                  shrink-0"> CONTACT ME

                </button></Link>
   
              </motion.button>
              <div>
                
     
              </div>

              {/* Hamburger Menu */}
              <button
                onClick={() => setOpen(true)}
                className="shrink-0 w-12 h-12 rounded-full border bg-white border-white/20
                flex items-center justify-center transition-colors"
              >
                <svg
                  className="w-6 h-6 "
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>

            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-50 bg-[#1E1E1E]"
          >
            <div className="max-w-[1300px] mx-auto w-full ">
              
              {/* Mobile Header */}
              <div className="flex items-center px-6 md:px-0 justify-between h-20 border-b border-white/10">
                <span className="text-white text-xl lg:text-2xl font-light lowercase tracking-wide hover:opacity-70 transition-opacity">
                    <Link    to="/" >buildwithpelumi.
                </Link>
                </span>
                <button
                  onClick={() => setOpen(false)}
                  className="w-12 h-12 rounded-full border bg-white
                  flex items-center justify-center transition-colors"
                >
                  <svg
                    className="w-6 h-6 text-[#1E1E1E]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Mobile Menu */}
              <div className="flex flex-col px-6 md:px-0 justify-center h-[calc(100vh-5rem)]">
                <nav className="space-y-2  ">
                  {navItems.map((item, i) => (
                    <motion.div
                      key={item.name}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{
                        delay: i * 0.1,
                        duration: 0.4,
                        ease: [0.22, 1, 0.36, 1],
                      }}
                    >
                      <NavLink
                        to={item.path}
                        onClick={() => setOpen(false)}
                        className={({ isActive }) =>
                          `block text-4xl md:text-5xl font-light lowercase tracking-wide py-3
                          transition-colors duration-300
                          ${isActive ? "text-white" : "text-white/50 hover:text-white"}`
                        }
                      >
                        {item.name}
                      </NavLink>
                    </motion.div>
                  ))}
                </nav>

                {/* Mobile CTA */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="mt-12"
                >
                  <a
                    href="/Atoyebi_Pelumi_CV.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-[#7C6AE6] border-4 border-[#7C6AE6]
                    text-white font-semibold px-6 py-2 text-[16px]
                    hover:bg-black hover:text-[#E6D9FC] transition-colors"
                  >
                    MY RESUME
                  </a>
                </motion.div>

              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
